import { ProtectedDashboard } from "./pages/ProtectedDashboard";
import { AuthenticationError } from "./pages/AuthenticationError";
import { LoginRedirect } from "./pages/LoginRedirect";
import { NotFoundPage } from "./pages/NotFoundPage";
import { SignedOutPage } from "./pages/SignedOutPage";

export function App() {
  const pathname = normalizePathname(window.location.pathname);

  switch (pathname) {
    case "/":
      return <ProtectedDashboard />;
    case "/login":
      return <LoginRedirect />;
    case "/auth/error":
      return <AuthenticationError />;
    case "/signed-out":
      return <SignedOutPage />;
    default:
      return <NotFoundPage />;
  }
}

function normalizePathname(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}
